import React from 'react'

export default function Header() {
    return (
        <div className="header">
            <h3>Rupam Das</h3>
        </div>
    )
}
